import { render } from "./AccsModal.vue?vue&type=template&id=880adf46&scoped=true"
import script from "./AccsModal.vue?vue&type=script&lang=js"
export * from "./AccsModal.vue?vue&type=script&lang=js"

import "./AccsModal.vue?vue&type=style&index=0&id=880adf46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-880adf46"]])

export default __exports__